export default () => ({
  coupon: null,
  current: null,
  customerName: null,
  deliveryMethod: null,
  location: null,
  orderDate: null,
  paymentData: null,
  paymentMethod: null,
  previousOrder: null,
  products: [],
  useCredit: false,
  totalDiscount: 0,
  totalPrice: 0,
});
